import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ToolbarReactionIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        viewBox="0 0 32 32"
        className="Icon toolbar-reaction"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <rect width={32} height={32} fill="#1B2536" rx={4} />
            <path
                fill="#48505E"
                d="M16 7.00049C20.9706 7.00049 25 11.0299 25 16.0005C24.9997 20.9708 20.9704 25.0005 16 25.0005C11.0296 25.0005 7.00026 20.9708 7 16.0005C7 11.0299 11.0294 7.00049 16 7.00049ZM16 8.50049C11.8579 8.50049 8.5 11.8584 8.5 16.0005C8.50026 20.1424 11.858 23.5005 16 23.5005C20.142 23.5005 23.4997 20.1424 23.5 16.0005C23.5 11.8584 20.1421 8.50049 16 8.50049ZM19.7881 17.0005C20.3402 17.0005 20.6815 17.6782 20.3975 18.2114C19.3275 20.2198 17.8406 20.9995 16 20.9995C14.1594 20.9995 12.6725 20.2198 11.6025 18.2114C11.3185 17.6782 11.6598 17.0005 12.2119 17.0005H19.7881ZM12.9863 13.1646C13.5314 13.1646 13.9736 13.6062 13.9736 14.1509C13.9735 14.6955 13.5314 15.1372 12.9863 15.1372C12.4414 15.1371 11.9991 14.6954 11.999 14.1509C11.999 13.6062 12.4413 13.1647 12.9863 13.1646ZM18.9082 13.1646C19.4533 13.1646 19.8955 13.6062 19.8955 14.1509C19.8954 14.6955 19.4532 15.1372 18.9082 15.1372C18.3633 15.137 17.922 14.6954 17.9219 14.1509C17.9219 13.6063 18.3633 13.1648 18.9082 13.1646Z"
            />
        </g>
    </svg>
);
const Memo = memo(ToolbarReactionIcon);
export default Memo;
